import * as P from "fp-ts-routing";

export type LuciferRoute = {};

export const luciferPageMatch = P.lit("lucifer");
